import React, { CSSProperties } from 'react'
import styles from './CloseButton.module.scss'
import SmallCloseIcon from './SmallCloseIcon'
import BigCloseIcon from './BigCloseIcon'
import { TutorialElementProps } from '../Tutorial/Tutorial'
import { tutorialDataTestIds } from '../mocks/tutorial-mocks'

type CloseButtonProps = {
  closeProps: TutorialElementProps
  iconSize: 'small' | 'big'
  style?: CSSProperties
  className?: string
}

const CloseIcons = {
  small: <SmallCloseIcon />,
  big: <BigCloseIcon />,
}

const CloseButton = ({
  closeProps,
  iconSize,
  style = {},
  className = '',
}: CloseButtonProps) => (
  <button
    type="button"
    {...closeProps}
    className={`${styles.closeButton} ${className}`}
    style={{ ...style }}
    data-testid={tutorialDataTestIds.closeButton}
  >
    {CloseIcons[iconSize]}
  </button>
)

export default CloseButton
